/**
 * Filtro dinâmico por catálogo de colunas — cada coluna filtrável vira uma entrada do
 * catálogo ({ id, label, type, options?, test }); o consumidor decide quais filtros
 * ficam ativos (via useFiltroCatalogoDinamico) e aplica sobre o array já carregado.
 */

function paraTexto(valor) {
  return valor == null ? "" : String(valor);
}

/** Filtro de texto: substring, sem diferenciar maiúsculas/minúsculas. */
export function testeTexto(getter) {
  return (row, valor) => {
    const v = paraTexto(valor).trim().toLowerCase();
    if (!v) return true;
    const raw = getter(row);
    if (raw == null) return false;
    return paraTexto(raw).toLowerCase().includes(v);
  };
}

/** Filtro de igualdade exata (select). */
export function testeSelect(getter) {
  return (row, valor) => {
    if (!valor) return true;
    return paraTexto(getter(row)) === paraTexto(valor);
  };
}

/**
 * Filtro de múltipla escolha: a linha passa se o valor for IGUAL a qualquer opção marcada.
 * Nada marcado, ou todas as `total` opções marcadas ("Todos"), = tudo (inclui valores fora da lista).
 */
export function testeMultiSelect(getter, total) {
  return (row, valores) => {
    if (!Array.isArray(valores) || valores.length === 0 || valores.length === total) return true;
    return valores.includes(paraTexto(getter(row)));
  };
}

/** Filtro numérico min/máx. */
export function testeRange(getter) {
  return (row, valor, valor2) => {
    const min = valor === "" || valor == null ? null : Number(valor);
    const max = valor2 === "" || valor2 == null ? null : Number(valor2);
    const val = Number(getter(row));
    if (min != null && !Number.isNaN(min) && val < min) return false;
    if (max != null && !Number.isNaN(max) && val > max) return false;
    return true;
  };
}

/** Filtro de período — compara strings YYYY-MM (mesmo formato do <input type="month">). */
export function testePeriodo(getter) {
  return (row, valor, valor2) => {
    const raw = paraTexto(getter(row));
    const ym = raw.length >= 7 ? raw.slice(0, 7) : "";
    if (!ym) return true;
    if (valor && ym < valor) return false;
    if (valor2 && ym > valor2) return false;
    return true;
  };
}

/**
 * @param {Array<object>} rows
 * @param {Array<{id: string, value: string, value2: string}>} ativos
 * @param {Array<{id: string, test: Function}>} catalog
 */
export function aplicarFiltroCatalogo(rows, ativos, catalog) {
  const lista = Array.isArray(rows) ? rows : [];
  if (!ativos || !ativos.length) return lista.slice();

  const catalogById = {};
  (catalog || []).forEach((c) => {
    catalogById[c.id] = c;
  });

  return lista.filter((row) =>
    ativos.every((af) => {
      const def = catalogById[af.id];
      if (!def || !def.test) return true;
      // 4º argumento: o filtro ativo inteiro (ex.: o modo do filtro de vigência).
      return def.test(row, af.value, af.value2, af);
    })
  );
}
